<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'
import { useWorkspaceSettingsStore } from '../../stores/workspace-settings-store'
import { detectTimezone } from '@/modules/shared/utils/timezone'

const onboardingStore = useWorkspaceOnboardingStore()
const settingsStore = useWorkspaceSettingsStore()

const form = ref({ time_zone: '', default_currency_code: 'USD' })

const timezones = computed(() => onboardingStore.options?.timezones ?? [])
const currencies = computed(() => onboardingStore.options?.currencies ?? [])

watch(
  () => onboardingStore.workspace,
  (ws) => {
    if (!ws) return
    form.value.time_zone = ws.time_zone || detectTimezone(timezones.value)
    form.value.default_currency_code = ws.default_currency_code ?? 'USD'
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  await settingsStore.updateWorkspace(
    {
      time_zone: form.value.time_zone,
      default_currency_code: form.value.default_currency_code,
    },
    { silent: true },
  )
  await onboardingStore.fetch()
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <div class="space-y-4">
      <fieldset>
        <label for="onboarding_tz" class="block text-sm font-medium text-gray-700">Time zone</label>
        <select
          id="onboarding_tz"
          v-model="form.time_zone"
          class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-300 focus:ring focus:ring-sky-200 focus:ring-opacity-50"
        >
          <option value="">Select time zone...</option>
          <option v-for="tz in timezones" :key="tz.value" :value="tz.value">{{ tz.label }}</option>
        </select>
      </fieldset>

      <fieldset>
        <label for="onboarding_currency" class="block text-sm font-medium text-gray-700">Default currency</label>
        <select
          id="onboarding_currency"
          v-model="form.default_currency_code"
          class="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-sky-300 focus:ring focus:ring-sky-200 focus:ring-opacity-50"
        >
          <option v-for="curr in currencies" :key="curr" :value="curr">{{ curr }}</option>
        </select>
      </fieldset>
    </div>
  </div>
</template>
